import {
  MDBCollapse,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBNavItem,
} from "mdbreact";
import React, { Component } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "./NavHeader.scss";
import classes from "./NavHeader.module.scss";
import CategoryMenu from "./MegaMenu/CategoryMenu";
import Aux from "../../../hoc/Auxillary";
import {
  isBrowser,
  isIPad13,
  isMobileOnly,
  isTablet,
} from "react-device-detect";
import { gaTracker } from "../../../helper/Helper";
import { Context } from "../../../context/Wrapper";
import { LoadingSimple } from "../../UI/LoadingBar";
import { FormattedMessage } from "react-intl";
import ButtonLang from "../../UI/ButtonLang/ButtonLang";
import { LANG_EN } from "../../../constants";

//add by hendra on 13 oct 2020 06.00 pm
const [paramCategory, paramAction] = ["Search", "Search Products"];

class NavHeaderHook extends Component {
  constructor(props) {
    // console.log('[NavHeader.js] constructor', props);
    super(props);
    this.state = {
      isOpen: false,
      isOpenMegaMenu: false,
      focus: false,
      modalLogin: false,
      collapseID: "",
      hasError: false,
      keywords: "",
      locale: "",
    };
  }

  static contextType = Context;

  gotoPage = (
    category_slug,
    category_id,
    sub_category_slug,
    sub_category_id,
    category_title
  ) => {
    this.doSetLocalStorage(
      category_slug,
      category_id,
      sub_category_slug,
      sub_category_id,
      category_title
    );
    // this.props.history.push({
    //     pathname: '/product-categories/' + category_slug
    //     , search: '?selected_sub_category=' + sub_category_slug
    // });

    //experimental
    if (sub_category_slug === 0) {
      sub_category_slug = "";
    }
    //experimental
    this.props.history.push({
      pathname:
        "/product-categories/" + category_slug + "/" + sub_category_slug,
    });

    this.setState({ isOpenMegaMenu: !this.state.isOpenMegaMenu });
  };

  /*This function call from Menu in Mobile Version*/
  gotoCategoryPage = (
    category_slug,
    category_id,
    sub_category_slug,
    sub_category_id,
    category_title
  ) => {
    this.doSetLocalStorage(
      category_slug,
      category_id,
      sub_category_slug,
      sub_category_id,
      category_title
    );
    this.props.history.push({
      pathname: "/product-categories/" + category_slug,
      search: "?selected_sub_category=" + sub_category_slug,
    });
    this.setState({ isOpen: !this.state.isOpen });
  };

  doSetLocalStorage = (
    category_slug,
    category_id,
    sub_category_slug,
    sub_category_id,
    category_title
  ) => {
    localStorage.setItem("selected_category_id", category_id);
    localStorage.setItem("selected_category", category_slug);
    localStorage.setItem("selected_sub_category", sub_category_slug);
    localStorage.setItem("selected_sub_category_id", sub_category_id);
    localStorage.setItem("ct_param_product_category", category_title);
  };

  doSearchProducts = (event) => {
    const keyword = event.target.value;
    if (!this.state.hasError) {
      if (event.key === "Enter") {
        this.props.history.push("/search-products/" + keyword.toLowerCase());
        //add by hendra on 13 oct 2020 06.00 pm
        gaTracker(paramCategory, paramAction, keyword.toLowerCase());

        if (isMobileOnly || isTablet || isIPad13) {
          this.toggleCollapse();
        } else {
          this.toggleClosedMegaMenu();
        }
      }
    }
  };

  doSearchProductsButton = () => {
    if (this.state.keywords === "") {
      this.setState({ hasError: true });
    } else {
      if (!this.state.hasError) {
        this.props.history.push(
          "/search-products/" + this.state.keywords.toLowerCase()
        );
        //add by hendra on 13 oct 2020 06.00 pm
        gaTracker(
          paramCategory,
          paramAction,
          this.state.keywords.toLowerCase()
        );

        if (isMobileOnly || isTablet || isIPad13) {
          this.toggleCollapse();
        } else {
          this.toggleClosedMegaMenu();
        }
      }
    }
  };

  onChangeHandler = (event) => {
    // if (/\s/.test(event.target.value) || event.target.value.trim().length < 3) {
    if (event.target.value.trim().length < 3) {
      this.setState({ hasError: true, keywords: "" });
    } else if (event.target.value.length > 2) {
      this.setState({ hasError: false, keywords: event.target.value });
    }
  };

  render() {
    let mainMenuList = <p>No data rendered</p>;
    if (this.props.dataMenu !== null && this.props.dataSubMenu !== null) {
      mainMenuList = this.props.dataMenu.map((menu) => {
        const menuCategory = (
          <Aux>
            {menu.name}
            <div
              className={["fas fa-angle-down", classes.Navbar_arrow].join(" ")}
            />
          </Aux>
        );

        return (
          <MDBNavItem
            key={menu.id}
            onClick={() =>
              this.menuHandler(
                menu,
                this.context.locale === LANG_EN ? menu.name : menu.name_en
              )
            }
          >
            <div className={classes.MdbNavbarCustom_navLinkCustom}>
              {menu.has_child ? menuCategory : menu.name}
            </div>
          </MDBNavItem>
        );
      });

      if (isMobileOnly) {
        mainMenuList = (
          <>
            <MDBNavItem>
              <div
                onClick={() => this.menuHandler("/", "Home")}
                className={classes.MdbNavbarCustom_navLinkCustom}
              >
                <strong>
                  <FormattedMessage
                    id={"global.header.navigation.home"}
                    defaultMessage={"Home"}
                  />
                </strong>
              </div>
            </MDBNavItem>
            <MDBNavItem>
              <div
                onClick={() => this.menuHandler("/about", "About")}
                className={classes.MdbNavbarCustom_navLinkCustom}
              >
                <strong>
                  <FormattedMessage
                    id={"global.header.navigation.about"}
                    defaultMessage={"About JBFS"}
                  />
                </strong>
              </div>
            </MDBNavItem>
            <MDBNavItem>
              <div className={classes.MdbNavbarCustom_navLinkCustom}>
                <strong>
                  <FormattedMessage
                    id={"global.header.navigation.catalog"}
                    defaultMessage={"Catalog"}
                  />
                </strong>
              </div>
            </MDBNavItem>
            <ul className={"Mobile_category_menu"}>
              {this.props.product_categories.map((item, index) => {
                return (
                  <div key={`${item.product_category_cd}${index}`}>
                    <MDBNavItem
                      onClick={() =>
                        this.gotoCategoryPage(item.slug, 0, 0, "", item.name)
                      }
                    >
                      <div className={classes.MdbNavbarCustom_navLinkCustom}>
                        <img
                          src={item.image_icon}
                          alt={"Japfa Food | Food Solutions"}
                          width="22.5px"
                        />
                        &nbsp;
                        <span>{item.name}</span>
                      </div>
                    </MDBNavItem>
                  </div>
                );
              })}
            </ul>

            <MDBNavItem>
              <div
                onClick={() => this.menuHandler("/menu-ideas", "Menu Ideas")}
                className={classes.MdbNavbarCustom_navLinkCustom}
              >
                <strong>
                  <FormattedMessage
                    id={"global.header.navigation.menuideas"}
                    defaultMessage={"Menu Ideas"}
                  />
                </strong>
              </div>
            </MDBNavItem>
            <MDBNavItem>
              <div
                onClick={() =>
                  this.menuHandler("/news-events", "News and Events")
                }
                className={classes.MdbNavbarCustom_navLinkCustom}
              >
                <strong>
                  <FormattedMessage
                    id={"global.header.navigation.newsevents"}
                    defaultMessage={"News & Events"}
                  />
                </strong>
              </div>
            </MDBNavItem>
          </>
        );
      }
    }

    const liCategoryMenu =
      this.props.product_categories &&
      this.props.product_categories.length < 1 ? (
        <LoadingSimple />
      ) : (
        <CategoryMenu
          product_categories={this.props.product_categories}
          product_sub_categories={this.props.product_sub_categories}
          gotoPage={this.gotoPage}
          toggleClosed={this.toggleClosedMegaMenu}
        />
      );

    let additionalScroll = "";
    if (isMobileOnly) {
      additionalScroll =
        this.props.product_categories.length > 6 ? classes.Scroll : "";
    }

    return (
      <Router>
        <MDBNavbar
          dark
          expand="lg"
          sticky="top"
          scrolling={false} // className={"custom-mdbnavbar"}
          className={["jbfs-header", classes.MdbNavbarCustom_section].join(" ")}
        >
          <div className={classes.MdbNavbarCustom_topLevelBar} />

          <div
            className={["jbfs-wrapper", classes.MdbNavbarCustom_wrapper].join(
              " "
            )}
          >
            {/*LOGO*/}
            <MDBNavbarBrand
              onClick={() => this.goBacks()}
              className={classes.Navbar_logo}
            >
              {this.props.setting && this.props.setting.length < 1 ? (
                <LoadingSimple />
              ) : (
                <img
                  src={this.props.setting.logo}
                  className={classes.MdbNavbarCustom_navbarBrand_imgBrand}
                  alt="logo"
                />
              )}
            </MDBNavbarBrand>
            {/*END LOGO*/}

            {isMobileOnly || isTablet || isIPad13 ? (
              <button
                style={{ outline: "0" }}
                className={[classes.ButtonLang, ""].join(" ")}
              >
                <ButtonLang change={this.props.selectLang} />
              </button>
            ) : (
              ""
            )}

            <MDBCollapse id="navbarCollapse3" isOpen={this.state.isOpen} navbar>
              {/*LIST MENU*/}
              <MDBNavbarNav
                left
                className={[
                  classes.MdbNavbarCustom_navbarNav,
                  additionalScroll,
                ].join(" ")}
              >
                {mainMenuList}
              </MDBNavbarNav>
              {/*END LIST MENU*/}

              {/*Add on 17 dec 2020*/}
              {isBrowser ? (
                <MDBNavbarNav right className={classes.MdbNavbarCustom_lang}>
                  <ButtonLang change={this.props.selectLang} />
                </MDBNavbarNav>
              ) : (
                ""
              )}

              <MDBNavbarNav
                right
                style={{ width: "100px", fontSize: "150%" }}
                hidden
              >
                <select
                  onChange={(e) => this.props.selectLang(e.target.value)}
                  className="browser-default custom-select"
                  value={this.context.locale}
                >
                  <option value="en-us">EN</option>
                  <option value="id">ID</option>
                </select>
              </MDBNavbarNav>

              {/*Searching Component start*/}
              <MDBNavbarNav right>
                <MDBNavItem>
                  <div className={classes.MdbNavItem_searchContainer}>
                    <React.Fragment>
                      <div className={classes.MdbNavItem_searchContainer}>
                        <i
                          onClick={this.doSearchProductsButton}
                          className={[
                            "fa fa-search",
                            classes.NavSearchIcon,
                          ].join(" ")}
                        />
                        {/*<input placeholder={"Search JAPFA Product"}*/}
                        <FormattedMessage
                          id={"global.header.search.placeholder"}
                          defaultMessage={"Search JAPFA Product"}
                        >
                          {(msg) => (
                            <input
                              placeholder={msg}
                              className={[classes.MdbNavItem_searchInput].join(
                                " "
                              )}
                              type="text"
                              onChange={(event) => this.onChangeHandler(event)}
                              onFocus={(event) => this.onChangeHandler(event)}
                              onBlur={() => this.setState({ hasError: false })}
                              onKeyPress={(event) =>
                                this.doSearchProducts(event)
                              }
                            />
                          )}
                        </FormattedMessage>
                      </div>
                    </React.Fragment>
                    {this.state.hasError && (
                      <div
                        className={[
                          "jbfs-search-validation",
                          classes.JbfsSearch_validation,
                        ].join(" ")}
                      >
                        <FormattedMessage
                          id={"global.header.search.notification"}
                          defaultMessage={"Please input minimum 3 characters !"}
                        />
                      </div>
                    )}
                  </div>
                </MDBNavItem>
              </MDBNavbarNav>
              {/*Search Component end*/}
            </MDBCollapse>

            {/*NavbarToggle = BurgerButton*/}
            {/*) : ''}*/}
            <MDBNavbarToggler
              caret={"true"}
              type={"button"}
              className={["mdbnavbarcustom-burger-button-sm"].join(" ")}
              onClick={this.toggleCollapse}
            />
          </div>
        </MDBNavbar>
        {/*Region Mega Menu Start*/}
        {this.state.isOpenMegaMenu ? liCategoryMenu : null}
        {/*End Region Mega Menu*/}
      </Router>
    );
  } //end render()

  goBacks = () => {
    this.props.history.push("/");
    this.setState({ isOpenMegaMenu: false });
  };

  toggleClosedMegaMenu = () => {
    this.setState({ isOpenMegaMenu: false });
  };

  toggleCollapse = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleFocus = () => {
    this.setState({ focus: !this.state.focus });
  };

  menuHandler = (selectedMenu, paramMenuTitle) => {
    localStorage.setItem("selected_page_title", paramMenuTitle);

    if (selectedMenu instanceof Object) {
      if (selectedMenu.has_child) {
        this.setState({ isOpenMegaMenu: !this.state.isOpenMegaMenu });
      } else {
        this.props.history.push(selectedMenu.url);
        this.setState({ isOpenMegaMenu: false });
      }
    } else {
      this.props.history.push(selectedMenu);
      this.setState({ isOpen: !this.state.isOpen });
    }
  };

  componentDidMount() {
    document.body.classList.remove("modal-open");
  }
}

export default withRouter(React.memo(NavHeaderHook));
